import React from 'react';
import { Table } from 'antd';
import type { TableProps } from 'antd';

const TableResizable: React.FC<TableProps<any>> = (props) => {
  return <Table {...props} />;
};

export default TableResizable;
